import { AxiosError } from "axios";
import loggingService from "common/logging/loggingService";
import ValidationError from "common/validationError";

export default function ThrowsValidationError(): MethodDecorator {
    return function (target: object, key: string | symbol, descriptor: PropertyDescriptor | undefined) {
        if (descriptor === undefined) {
            descriptor = Object.getOwnPropertyDescriptor(target, key);
        }
        if (descriptor === undefined) {
            throw new Error(`target has no descriptor for key "${String(key)}"`)
        }
        const originalMethod: (...args: unknown[]) => Promise<unknown> = descriptor.value;


        descriptor.value = function (...args: unknown[]) {
            return Reflect.apply(originalMethod, this, args)
                .catch(function (error: AxiosError) {
                    const response = error.response;

                    loggingService.error(`Error in ${target.constructor.name}.${key.toString()}`, error);

                    let errors: string[] | undefined;
                    switch (response?.status) {
                        case 400:
                            errors = (response.data as { errors: string[] }).errors;
                            break;
                        case 403:
                        case 404:
                            errors = response.data as string[];
                            break;
                    }

                    throw new ValidationError(errors ?? ["An unknown error occurred"]);
                });
        }
    }
}